<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #beforeBtn>
        <CompositeFormCtrl ref="comFormCtrl" :options="searchKeyOptions" @onChange="onComSearchChange">
        </CompositeFormCtrl>
      </template>
    </SearchField>

    <Table ref="table" :tableHeight="tableHeight" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
    </Table>
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";
import mixin from "../mixin";

export default {
  name: "ContractList",
  mixins: [tableMixin, mixin],
  data() {
    return {
      baseUrl: 'contract',
      getListUrl: 'orderec',
      formInline: {
        ischeck: 1,
        isstatus: 2,
      },
      cols: [
        { prop: "order_num", label: "订单编号", width: 150 },
        { prop: "fleet_nickname", label: "车队长" },
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "driver", label: "司机" },
        { prop: "name", label: "货物名称" },
        { prop: "shname", label: "客户名称" },
        { prop: "coaddress", label: "装货地址" },
        { prop: "enaddress", label: "卸货地址" },
        { prop: "starttime", label: "装货日期", width: 120 },
      ],
      btns: [
        {
          ...this.feeBtn,
          cb: ({ id, isstatus }) => {
            // console.log(id)
            let mode = 'view'
            if (isstatus == 4) {
              mode = 'edit'
            }
            if (this.user.user_group_id == 5) {
              mode = 'edit'
            }
            this.$router.push(
              `/order/nocontractfee?id=${id}&mode=${mode}`
            );
          },
        },
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/order/contractview3?id=${id}&mode=view`
            );
          },
        },
      ],
    };
  },
  methods: {
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const obj = this.dataObjHandler(v)
          obj.open = v.isvoice + ''
          return obj
        })
      }
      // console.log(this.tableData)
    },
    toggleDisplay({ id }) {
      let url = `order/upstatus`;
      const params = {
        // userid: this.user.id,
        id,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    const { user_group_id, id } = this.user
    if ([1].includes(user_group_id) && id == 1) {
      this.btns.push({
        ...this.delBtn,
        cb: ({ order_num }) => {
          this.delete(order_num)
        },
      })

      this.btns[1] = {
        ...this.editBtn,
        cb: ({ id }) => {
          this.$router.push(
            `/order/contractview2?id=${id}&mode=view`
          );
        },
      }
    }
    if ([5].includes(user_group_id)) {
      this.btnView = {
        ...this.viewBtn,
        cb: ({ id }) => {
          this.$router.push(
            `/order/contractview21?id=${id}&mode=view`
          );
        },
      }
    }
    if ([2, 3, 4].includes(user_group_id)) {
      this.btns.length = 0
    }
  },
};
</script>

<style lang="less" scoped>
.table-wrap {
  /deep/ .el-table {
    .el-switch {
      &.inactive {
        .el-switch__core::after {
          content: '否';
          line-height: 17px;
          text-indent: 18px;
          color: #fff;
        }
      }

      &.active {
        .el-switch__core::after {
          content: '是';
          line-height: 17px;
          text-indent: -34px;
          color: #fff;
        }
      }
    }

    .overTime {
      width: 14px;
      height: 14px;
      border-radius: 100%;
      display: inline-block;
      vertical-align: top;
      margin-top: 7px;
      background: #ffe100;

      &.type1 {
        background: #98e098;
      }

      &.type2 {
        background: #fd5b5b;
      }
    }
  }
}

/deep/ .el-button.is-circle {
  padding: 5px;
  color: #96999f;
  background: #f2f6fc;
}
</style>